import { useEffect, useMemo, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const DEFAULT_BRANDING = {
  enabled: false,
  sidebarEnabled: false,
  brandName: "LastWish Box",
  publicBrandName: "LastWish Box",
  logoUrl: "/logo-placeholder.png",
  logoPath: "",
  colors: {
    primary: "#2a0516",
    secondary: "#645155",
    accent: "#f15822",
  },
};

function normalizeBranding(tenantData = {}) {
  const b = tenantData?.branding || {};
  const enabled = b?.enabled === true;

  if (!enabled) {
    return { ...DEFAULT_BRANDING };
  }

  return {
    enabled: true,
    sidebarEnabled: b?.sidebarEnabled === true,
    brandName:
      String(b?.brandName || tenantData?.name || DEFAULT_BRANDING.brandName).trim() ||
      DEFAULT_BRANDING.brandName,
    publicBrandName:
      String(b?.publicBrandName || b?.brandName || tenantData?.name || DEFAULT_BRANDING.publicBrandName).trim() ||
      DEFAULT_BRANDING.publicBrandName,
    logoUrl: String(b?.logoUrl || "").trim() || DEFAULT_BRANDING.logoUrl,
    logoPath: String(b?.logoPath || "").trim() || "",
    colors: {
      primary: String(b?.colors?.primary || DEFAULT_BRANDING.colors.primary).trim() || DEFAULT_BRANDING.colors.primary,
      secondary: String(b?.colors?.secondary || DEFAULT_BRANDING.colors.secondary).trim() || DEFAULT_BRANDING.colors.secondary,
      accent: String(b?.colors?.accent || DEFAULT_BRANDING.colors.accent).trim() || DEFAULT_BRANDING.colors.accent,
    },
  };
}

export default function useTenantBranding(user) {
  const tenantId = String(user?.primaryTenantId || user?.tenantId || "").trim();
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  useEffect(() => {
    let ignore = false;

    async function load() {
      if (!tenantId) {
        if (!ignore) setBranding(DEFAULT_BRANDING);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "tenants", tenantId));
        if (!snap.exists()) {
          if (!ignore) setBranding(DEFAULT_BRANDING);
          return;
        }

        const tenantData = { id: snap.id, ...snap.data() };
        if (!ignore) setBranding(normalizeBranding(tenantData));
      } catch {
        if (!ignore) setBranding(DEFAULT_BRANDING);
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, [tenantId]);

  return useMemo(() => branding, [branding]);
}
